// /src/NavBar.js
import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
import logo from './logo.jpg'; // Adjust the path to your logo file

const NavBar = () => {
    const [top, setTop] = useState(!window.scrollY);
    const [isOpen, setIsOpen] = useState(false);

    function handleClick() {
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        const scrollHandler = () => {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler);
    }, [top]);

    return (
        <nav
            style={{ backgroundColor: '#f8f6f6' }}
            className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out ${!top ? 'shadow-lg' : ''}`}
        >
            <div className="container mx-auto flex flex-wrap justify-between items-center py-4 px-4 lg:px-24">
                {/* Left Side: Logo */}
                <HashLink smooth to="/#hero" className="flex items-center pl-2 sm:pl-4 md:pl-4 lg:pl-20">
                    <img src={logo} alt="Company Logo" className="h-8 w-auto mr-2 sm:h-12 sm:mr-3" />
                    <h1 className="font-lato text-xl sm:text-2xl md:text-2xl text-gray-600">attune integrations</h1>
                </HashLink>

                {/* Hamburger Menu Icon (mobile) */}
                <button className="lg:hidden p-2 rounded-lg text-blue-900" onClick={handleClick}>
                    <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        {isOpen ? (
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                            />
                        ) : (
                            <path
                                fillRule="evenodd"
                                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2z"
                            />
                        )}
                    </svg>
                </button>

                {/* Desktop Navigation Links */}
                <div className="hidden lg:flex space-x-1 items-right">
                    <NavLinks />
                </div>

                {/* Mobile Navigation */}
                <div
                    className={`${
                        isOpen ? 'block' : 'hidden'
                    } lg:hidden w-full mt-4 bg-white shadow-lg rounded-md py-4`}
                >
                    <NavLinks />
                </div>
            </div>
        </nav>
    );
};

export default NavBar;
